const Percent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='14' height='14' viewBox='0 0 14 14' fill='currentColor' {...props}>
    <path
      d='M11.7617 2.2383C11.9753 2.45187 11.9753 2.79813 11.7617 3.0117L3.0117 11.7617C2.79813 11.9753 2.45187 11.9753 2.2383 11.7617C2.02473 11.5481 2.02473 11.2019 2.2383 10.9883L10.9883 2.2383C11.2019 2.02473 11.5481 2.02473 11.7617 2.2383Z'
      fill='currentColor'
    />
    <path
      d='M3.9375 5.25C3.21263 5.25 2.625 4.66237 2.625 3.9375C2.625 3.21263 3.21263 2.625 3.9375 2.625C4.66237 2.625 5.25 3.21263 5.25 3.9375C5.25 4.66237 4.66237 5.25 3.9375 5.25ZM3.9375 6.125C5.14562 6.125 6.125 5.14562 6.125 3.9375C6.125 2.72938 5.14562 1.75 3.9375 1.75C2.72938 1.75 1.75 2.72938 1.75 3.9375C1.75 5.14562 2.72938 6.125 3.9375 6.125Z'
      fill='currentColor'
    />
    <path
      d='M10.0625 11.375C9.33763 11.375 8.75 10.7874 8.75 10.0625C8.75 9.33763 9.33763 8.75 10.0625 8.75C10.7874 8.75 11.375 9.33763 11.375 10.0625C11.375 10.7874 10.7874 11.375 10.0625 11.375ZM10.0625 12.25C11.2706 12.25 12.25 11.2706 12.25 10.0625C12.25 8.85438 11.2706 7.875 10.0625 7.875C8.85438 7.875 7.875 8.85438 7.875 10.0625C7.875 11.2706 8.85438 12.25 10.0625 12.25Z'
      fill='currentColor'
    />
  </svg>
);

export default Percent;
